import request from "request";
import { apiUrl } from "./index";

// The browser split queue: tracked URLs screenhunter can't capture (bot walls,
// press-and-hold, Cloudflare) are promoted per platform, captured by hand in
// the DWW Browser app, and skipped by screenhunter while they're there.

// Runs and queue rows captured in DWW Browser carry this `source`.
export const BROWSER_SOURCE = "dww-browser";
export const isBrowserCapture = item => !!item && item.source === BROWSER_SOURCE;

// tracked_urls marks a promoted platform with <platform>_capture_source.
export const isPromotedInRow = (trackedUrl, platform) =>
  !!trackedUrl && trackedUrl[`${platform}_capture_source`] === "browser";

const ERROR_MESSAGES = {
  not_tracked: "This URL isn't a tracked URL, so it can't be queued.",
  "Not authed": "Only admins can change the browser queue.",
};

const handleResponse = (resolve, reject) => (err, res, body) => {
  if (err) {
    reject(new Error(err.message || "Network error"));
    return;
  }
  let json = null;
  try {
    json = body ? JSON.parse(body) : null;
  } catch (e) {
    json = null;
  }
  if (res.statusCode >= 400 || !json || json.error) {
    const reason = json && json.error;
    reject(
      new Error(
        ERROR_MESSAGES[reason] ||
          reason ||
          `Request failed (HTTP ${res.statusCode})`
      )
    );
    return;
  }
  resolve(json);
};

// -> {url, tracked, desktop: {promoted, job}, mobile: {promoted, job}}
export const getSplitQueueState = (token, url) =>
  new Promise((resolve, reject) => {
    request(
      {
        url: `${apiUrl}/v1/admin/v2/split-queue/state?url=${encodeURIComponent(
          url
        )}`,
        headers: {
          Authorization: token,
        },
      },
      handleResponse(resolve, reject)
    );
  });

// -> {jobs: [{job_id, url, platform, status, ...}]}: every URL + platform in
// the manual capture queue, by url.
export const listSplitQueue = token =>
  new Promise((resolve, reject) => {
    request(
      {
        url: `${apiUrl}/v1/admin/v2/split-queue/jobs`,
        headers: {
          Authorization: token,
        },
      },
      handleResponse(resolve, reject)
    );
  });

const post = (path, token, form) =>
  new Promise((resolve, reject) => {
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/split-queue/${path}`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: token,
        },
        form,
      },
      handleResponse(resolve, reject)
    );
  });

export const promoteToSplitQueue = (token, url, platform) =>
  post("promote", token, { url, platform });

export const releaseFromSplitQueue = (token, url, platform) =>
  post("release", token, { url, platform });
